import moment from "moment";
const dateFormat = "DD";

export const mountDataColumnAndLineCashFlow = (res) => {
  let dataSource = {
    chart: {
      theme: "gammel",
      drawcustomlegendicon: "1",
      adjustdiv: "0",
      pYAxisName: "Lançamentos",
      sYAxisName: "Saldo",
      plottooltext: "$label, $seriesname: $dataValue",
      palettecolors: "#ED5E80,#2A8DEB",
      legendposition: "top",
      syncAxisLimits: "1",
      numberPrefix: "R$ ",
      //Disabling number scale compression
      formatNumberScale: "0",
      //Defining custom decimal separator
      decimalSeparator: ",",
      //Defining custom thousand separator
      thousandSeparator: ".",
    },

    categories: [
      {
        category: mountLabel(res),
        fontSize: "15px",
      },
    ],
    dataset: [
      {
        dataset: [
          {
            seriesname: "Pagamentos",
            data: mountData(res, "PAID"),
          },
          {
            seriesname: "Recebimentos",
            data: mountData(res, "RECEIVE"),
          },
        ],
      },
    ],
    lineset: [
      {
        seriesname: "Saldo Final",
        showvalues: "0",
        color: "#FDCB50",
        anchorbgcolor: "#FDCB50",

        showanchors: "0",
        data: mountData(res, "AMOUNT"),
      },
    ],
  };
  return dataSource;
};
export const mountLabel = (data) => {
  const Arrylabel = [];
  if (data && data.length > 0) {
    data.forEach((data) => {
      Arrylabel.push({
        label: data.dueDate.substring(0, 2),
      });
    });
  }
  return Arrylabel;
};

export const mountData = (data, type) => {
  const Arrylabel = [];
  if (data && data.length > 0) {
    data.forEach((data) => {
      var dataItem = 0;

      switch (type) {
        case "PAID":
          dataItem = data.paid;
          break;
        case "RECEIVE":
          dataItem = data.receive;
          break;
        case "AMOUNT":
          dataItem = data.profit;
          break;

        default:
          break;
      }
      Arrylabel.push({
        value: dataItem,
      });
    });
  }
  return Arrylabel;
};
